/**
 * The technician's Hey Nova switch, kept per browser. Off until they turn it
 * on. (wakeWordSwitch.ts keeps it on the phone.)
 */
const KEY = 'novaAI.wakeWord';

export const loadWakeWordSwitch = async (): Promise<boolean> => {
  try {
    return window.localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
};

export const saveWakeWordSwitch = (on: boolean): void => {
  try {
    window.localStorage.setItem(KEY, on ? '1' : '0');
  } catch {
    // Private mode or storage off: it holds for this page, not the next.
  }
};

/** The engine the tester picked, kept the same way; '' until one is picked. */
const ENGINE_KEY = 'novaAI.wakeWordEngine';

export const loadWakeWordEngine = async (): Promise<string> => {
  try {
    return window.localStorage.getItem(ENGINE_KEY) ?? '';
  } catch {
    return '';
  }
};

export const saveWakeWordEngine = (engine: string): void => {
  try {
    window.localStorage.setItem(ENGINE_KEY, engine);
  } catch {
    // As above: it holds for this page.
  }
};
